import React from 'react';

const JS_RegExp_Methods = () => {
  return (
    <div >
      <h1>JS_RegExp_Methods</h1>
      <p>Placeholder component for: "JS RegExp Methods"</p>
    </div>
  );
};

export default JS_RegExp_Methods;
